// extracted by mini-css-extract-plugin
export default {"content":"content-1VQSdr","shakeShake":"shakeShake-1CacCa"};